import { Link } from 'react-router-dom'

interface StoryCapBannerProps {
  storyCount: number
  cap: number
}

export function StoryCapBanner({ storyCount, cap }: StoryCapBannerProps) {
  const atCap = storyCount >= cap

  return (
    <div className="flex items-center justify-between gap-3 rounded-xl border border-border bg-muted/30 px-4 py-3">
      <div className="flex items-center gap-3">
        <div className="flex gap-1" aria-hidden="true">
          {Array.from({ length: cap }, (_, i) => (
            <span
              // biome-ignore lint/suspicious/noArrayIndexKey: decorative fixed-length meter — slot position is its identity
              key={i}
              className={
                i < storyCount
                  ? 'h-2 w-6 rounded-full bg-primary'
                  : 'h-2 w-6 rounded-full bg-muted-foreground/20'
              }
            />
          ))}
        </div>
        <p className="text-xs text-muted-foreground">
          <span className="font-semibold text-foreground">
            {storyCount} of {cap}
          </span>{' '}
          free stories used
        </p>
      </div>
      <Link
        to="/settings"
        className="flex-shrink-0 rounded-lg bg-primary px-3 py-1.5 text-xs font-semibold text-primary-foreground hover:opacity-90 transition-opacity"
      >
        {atCap ? 'Unlock unlimited' : 'Go unlimited'}
      </Link>
    </div>
  )
}
